import { post } from '@/utils/request'
import {get} from "../../utils/request";

// 角色管理-表格数据
export function getRoleListReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_LIST.NEW'
    })
}

// 角色管理-添加/编辑角色
export function addOrEditRoleReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_EDIT.Q_USERGROUP_EDIT'
    })
}

// 角色管理-删除角色
export function delRoleReq(data) {
    return post({
        data,
        // url: '!org/usergroup/~query/Q_USERGROUP_DEL'
        url: '!org/usergroup/~query/Q_USERGROUP_DEL.Q_USERGROUP_DEL'
    })
}

// 角色管理-授权详情 
export function getAuthDetailRoleReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_INFO.AUTHORIZATION_DETAIL'
    })
}

// 角色管理-根据角色返回用户（角色拥有的用户会有标识）  
export function getRoleByCodeReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_INFO.GET_USER_BY_CODE'
    })
}

// 角色管理-根据角色返回用户数  
export function getRoleAuthTotalReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_INFO.GET_USER_COUNT_BY_CODE'
    })
}

// 角色管理-根据角色id获取角色信息 
export function getRoleDetailReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_INFO.NEW'
    })
}

// 角色管理-给用户分配角色（授权） 
export function authRoleReq(data) {
    return post({
        data,
        url: '!org/usergroup/~query/Q_USERGROUP_INFO.USER_AUTHORIZATION'
    })
}


// 角色管理-获取所有角色 
export function getAllRoleDataReq(params) {
    return get({
        params,
        url: 'member/roles'
    })
}

// 角色管理-授权菜单树形数据  
// export function getAuthByRoleReq(data) {
export function getAuthTreeReq(data) {
    return post({
        data,
        url: '!sys/menu/~java/UserMenuManage.getUserMenu'
    })
}

// 角色管理-根据用户获取用户拥有的功能权限 (根据点击左边的角色获取右面要显示勾选数据) 
export function getAuthIsGouByRoleReq(data) {
    return post({
        data,
        url: '!sys/menu/~query/Q_MENUS_FUNCTION.Q_MENUS_FUNCTION_BY_ROLE'
    })
}

// 角色管理-取消授权  
export function cancelAuthReq(data) {
    return post({
        data,
        url: '!sys/security/~query/Q_USERGROUP_RESOURCE_DEL.BATCH'
    })
}

// 角色管理-授权   
export function addAuthReq(data) {
    return post({
        data,
        url: '!sys/security/~query/Q_USERGROUP_RESOURCE_ADD.BATCH'
    })
}


// 角色管理-确定授权    
export function confirmAddAuthReq(data) {
    return post({
        data,
        url: '!sys/security/~query/GET_ALL_ACCESS'
    })
}